import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Sentinel, Sentinels, CreateSentinel, UpdateSentinel } from "./pages";

export const SentinelsRouter = [
  <Route
    path="/sentinels"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Sentinels />
      </ProtectedRoute>
    }
  />,

  <Route path="/sentinel">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Sentinel />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateSentinel />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateSentinel />
        </ProtectedRoute>
      }
    />
  </Route>,
];

export const AdminSentinelsRouter = [
  <Route
    path="/sentinels"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Sentinels />
      </ProtectedRoute>
    }
  />,

  <Route path="/sentinel">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Sentinel />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateSentinel />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateSentinel />
        </ProtectedRoute>
      }
    />
  </Route>,
];

export const ClientSitesRouter = [];
